import React, { useState } from 'react';
import './Instrument.css';

function MeowInstrument({ onAddNote, selectedMeow }) {
  const [selectedNote, setSelectedNote] = useState(null);

  // 喵喵琴：从1 Do到高音7 Si，包含升调 (meow: 01-08)
  // song编号映射：
  // 中音区：#1#2#4#5#6 = 01-05, 1-7 = 06-0C
  // 高音区：高#1#2#4#5#6 = 0D-11, 高1-7 = 12-18
  const meowNotes = [
    // 中音区升调（0x01-0x05）
    { name: '#1 #Do', song: '01', meow: '01', type: 'sharp' },
    { name: '#2 #Re', song: '02', meow: '02', type: 'sharp' },
    { name: '#4 #Fa', song: '03', meow: '03', type: 'sharp' },
    { name: '#5 #So', song: '04', meow: '04', type: 'sharp' },
    { name: '#6 #La', song: '05', meow: '05', type: 'sharp' },
    // 中音区自然音（0x06-0x0C）
    { name: '1 Do', song: '06', meow: '06', type: 'natural' },
    { name: '2 Re', song: '07', meow: '07', type: 'natural' },
    { name: '3 Mi', song: '08', meow: '08', type: 'natural' },
    { name: '4 Fa', song: '09', meow: '01', type: 'natural' },
    { name: '5 So', song: '0A', meow: '02', type: 'natural' },
    { name: '6 La', song: '0B', meow: '03', type: 'natural' },
    { name: '7 Si', song: '0C', meow: '04', type: 'natural' },
    // 高音区升调（0x0D-0x11）
    { name: '高#1 Hi #Do', song: '0D', meow: '05', type: 'sharp' },
    { name: '高#2 Hi #Re', song: '0E', meow: '06', type: 'sharp' },
    { name: '高#4 Hi #Fa', song: '0F', meow: '07', type: 'sharp' },
    { name: '高#5 Hi #So', song: '10', meow: '08', type: 'sharp' },
    { name: '高#6 Hi #La', song: '11', meow: '01', type: 'sharp' },
    // 高音区自然音（0x12-0x18）
    { name: '高1 Do', song: '12', meow: '02', type: 'natural' },
    { name: '高2 Re', song: '13', meow: '03', type: 'natural' },
    { name: '高3 Mi', song: '14', meow: '04', type: 'natural' },
    { name: '高4 Fa', song: '15', meow: '05', type: 'natural' },
    { name: '高5 So', song: '16', meow: '06', type: 'natural' },
    { name: '高6 La', song: '17', meow: '07', type: 'natural' },
    { name: '高7 Si', song: '18', meow: '08', type: 'natural' },
  ];

  const handleNoteClick = (note) => {
    setSelectedNote(note);
    // 使用从 MeowSelector 选择的喵喵琴编号（保持16进制格式 01-08）
    const meowValue = selectedMeow || '01'; // 如果没有选择，默认使用 '01'
    // 确保 meow 值是两位16进制格式（带前导0）
    // 如果 selectedMeow 是数字，转换为字符串；如果是字符串但只有1位，添加前导0
    let meowHex = String(meowValue);
    if (meowHex.length === 1) {
      meowHex = `0${meowHex}`;
    }
    // 确保是16进制格式（01-08）
    onAddNote(meowHex.toUpperCase(), note.song);
  };

  return (
    <div className="instrument">
      <div className="instrument-title">
        <span className="icon">🐱</span>
        <div>
          <h3>喵喵琴</h3>
          <p className="subtitle">从1 Do 到高音7 Si</p>
        </div>
      </div>

      <div className="notes-grid meow-grid">
        {meowNotes.map((note, index) => (
          <button
            key={index}
            className={`note-btn meow-btn ${note.type === 'sharp' ? 'sharp-note' : ''} ${selectedNote?.name === note.name ? 'selected' : ''}`}
            onClick={() => handleNoteClick(note)}
          >
            <div className="note-name">{note.name}</div>
            <div className="note-hex">0x{note.song}</div>
          </button>
        ))}
      </div>

      <div className="help-text">
        <p>💡 点击音符添加到乐谱</p>
      </div>
    </div>
  );
}

export default MeowInstrument;

